import { defineStore } from "pinia";

export const useFormStore = defineStore("form", {
  state: () => ({
    formData: {},
    cardSections: [],
    lessonAssignmentsData: [],
    cardSectionsData: {},
    assignmentPayload: []
  }),
  actions: {
    setFormData(data) {
      this.formData = data;
    },
    setShownSections(data) {
      this.cardSections = data;
    },
    setCardSectionsData(data) {
      this.cardSectionsData = { ...this.cardSectionsData, ...data };
    },
    setLessonAssignments(data) {
      this.lessonAssignmentsData = data;
    },
    setAssignmentPayload(data) {
      this.assignmentPayload = [ ...data ];
    },
    clearLessonPersistent() {
      this.formData = {}
      this.cardSections = []
      this.lessonAssignmentsData = []
      this.cardSectionsData = {}
      this.assignmentPayload = []
    },
    clearAssignmentPayload() {
      this.assignmentPayload = [];
    }
  },
  persist: true
});
